
import {
  NotFoundStack
} from "./NotFound.styles";
import {
  GridMain,
  NotFoundComponent
} from "../../components";
import { useAuthStore } from "../../stores";

export function NotFoundPage() {
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  setSpinnerLoginVisible(false);

  return (

    <NotFoundStack>
      <GridMain>
        <NotFoundComponent/>
      </GridMain>
    </NotFoundStack>


  );
}
